import * as React from "react";
import InputRange from "react-input-range";
export class Slider extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            currentValue: this.props.value
        };
    }
    render() {
        if (this.props.onRelease) {
            return React.createElement(InputRange, { classNames: Slider.classNames, minValue: this.props.min, maxValue: this.props.max, step: this.props.step, value: this.state.currentValue, onChange: (value) => this.setState({ currentValue: value }), onChangeComplete: this.props.onChange });
        }
        else {
            return React.createElement(InputRange, { classNames: Slider.classNames, minValue: this.props.min, maxValue: this.props.max, step: this.props.step, value: this.props.value, onChange: this.props.onChange });
        }
    }
}
Slider.classNames = {
    activeTrack: "sliderTrackActive",
    disabledInputRange: "sliderDisabled",
    inputRange: "slider",
    labelContainer: "sliderLabelContainer",
    maxLabel: "sliderMaxLabel",
    minLabel: "sliderMinLabel",
    slider: "sliderHandle",
    sliderContainer: "sliderHandleContainer",
    track: "sliderTrack",
    valueLabel: "sliderValueLabel"
};
export class FileInput extends React.PureComponent {
    render() {
        return React.createElement("input", { className: this.props.className, type: "file", onChange: (event) => this.props.onChange(event.target.files), accept: this.props.accept });
    }
}
export class IconFileInput extends React.PureComponent {
    handleClick() {
        this._inputRef.click();
    }
    render() {
        return React.createElement("div", null,
            React.createElement("button", { className: this.props.className, title: this.props.title, onClick: this.handleClick.bind(this) },
                React.createElement("i", { className: this.props.iconName })),
            React.createElement("input", { style: { position: "absolute", zIndex: -1, opacity: 0 }, type: "file", ref: (ref) => { this._inputRef = ref; }, onChange: (event) => this.props.onChange(event.target.files), accept: this.props.accept }));
    }
}
export class LabelledCheckbox extends React.PureComponent {
    render() {
        return React.createElement("div", { className: this.props.className, onClick: () => { this.props.onChange(!this.props.state); } },
            React.createElement("p", null, this.props.label),
            React.createElement("input", { type: "checkbox", name: this.props.label, checked: this.props.state, onChange: (event) => { this.props.onChange(event.target.checked); } }));
    }
}
export class FAButton extends React.PureComponent {
    render() {
        return React.createElement("button", { title: this.props.title, className: this.props.className, onClick: () => { this.props.onClick(); }, disabled: this.props.disabled },
            React.createElement("i", { className: this.props.iconName }));
    }
}
export class Dropdown extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            dropdownVisible: false
        };
    }
    _handleDropdownClick() {
        this.setState({ dropdownVisible: !this.state.dropdownVisible });
    }
    render() {
        const objDivClasses = "dropdown" + (this.props.optionsDivClassName == undefined ? "" : " " + this.props.optionsDivClassName);
        return React.createElement("div", null,
            React.createElement(FAButton, { className: this.props.buttonClassName, title: this.props.title, iconName: this.props.iconName, onClick: () => { this._handleDropdownClick(); } }),
            this.state.dropdownVisible && React.createElement(ClickOutsideWatcher, { callback: () => this.setState({ dropdownVisible: false }) },
                React.createElement("div", { className: objDivClasses }, this.props.optionTitles.map((title, index) => {
                    return React.createElement(DropdownItem, { key: index, index: index, className: this.props.optionClassName, title: title, callback: (index) => { this._handleDropdownClick(); this.props.optionClickCallback(index); } });
                }))));
    }
}
export class DropdownItem extends React.Component {
    render() {
        const className = "dropdownItem buttonColorAnim" + (this.props.className == undefined ? "" : " " + this.props.className);
        return React.createElement("button", { className: className, onClick: () => { this.props.callback(this.props.index); } }, this.props.title);
    }
}
export class BoxSelect extends React.PureComponent {
    constructor(props) {
        super(props);
        this._selectOptionClicked = this._selectOptionClicked.bind(this);
        this.state = {
            selectVisible: false,
        };
        this._selectButton = React.createRef();
    }
    _selectOptionClicked(index) {
        this.props.selectedCallback(index, this.props.options[index]);
        this.setState({ selectVisible: false });
    }
    render() {
        const buttonClassName = "boxSelectButton" + (this.props.selectButtonClassName ? " " + this.props.selectButtonClassName : "");
        return React.createElement("div", { className: this.props.className, style: { display: "flex", flexDirection: "column", alignItems: "center", position: "relative" } },
            React.createElement("div", null,
                React.createElement("button", { className: (this.props.mainButtonClassName ? this.props.mainButtonClassName : "mainBoxSelectButton"), title: this.props.title, ref: this._selectButton, onClick: () => { this.setState({ selectVisible: !this.state.selectVisible }); } }, this.props.selected !== undefined ? this.props.options[this.props.selected] : (this.props.boxSelectTitle ? this.props.boxSelectTitle : this.props.children))),
            this.state.selectVisible && React.createElement(ClickOutsideWatcher, { className: "boxSelectWatcher", callback: () => { this.setState({ selectVisible: false }); } },
                React.createElement(BoxSelectOverlay, { buttonClassName: buttonClassName, selectButton: this._selectButton, options: this.props.options, selectOptionClickedCallback: this._selectOptionClicked })));
    }
}
class BoxSelectOverlay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            renderAbove: false,
        };
        this._overlayContainer = React.createRef();
    }
    componentDidMount() {
        let bottom = this._overlayContainer.current.getBoundingClientRect().bottom;
        if (bottom > window.innerHeight) {
            this.setState({ renderAbove: true });
        }
    }
    render() {
        const overlayClassName = "boxSelectOverlay" + (this.props.className ? " " + this.props.className : "");
        let options = this.props.options.map((value, index) => {
            return React.createElement("button", { className: this.props.buttonClassName, key: index, onClick: () => { this.props.selectOptionClickedCallback(index); } }, value);
        });
        let currentButton = this.props.selectButton.current;
        if (!this.state.renderAbove) {
            return React.createElement("div", { className: "boxSelectOverlayContainer", ref: this._overlayContainer, style: { top: currentButton.offsetHeight + 1 } },
                React.createElement("div", { className: "boxSelectOverlayArrow top" }),
                React.createElement("div", { className: overlayClassName }, options));
        }
        else {
            return React.createElement("div", { className: "boxSelectOverlayContainer", ref: this._overlayContainer, style: { top: -this._overlayContainer.current.offsetHeight - 1 } },
                React.createElement("div", { className: overlayClassName }, options),
                React.createElement("div", { className: "boxSelectOverlayArrow bottom" }));
        }
    }
}
export class SelectionGroup extends React.Component {
    render() {
        return React.createElement("div", { className: this.props.className }, this.props.buttonContents.map((value, index) => {
            let selected = false;
            if (index === this.props.selectedButton) {
                selected = true;
            }
            let title = undefined;
            if (this.props.buttonTitles && this.props.buttonTitles.length > index) {
                title = this.props.buttonTitles[index];
            }
            return React.createElement(SelectionButton, { key: index, title: title, className: this.props.buttonClassName, disabled: this.props.disabled, selected: selected, content: value, onClick: () => { this.props.onButtonClick(index); } });
        }));
    }
}
class SelectionButton extends React.Component {
    render() {
        const classes = "selectionButton" + (this.props.selected ? " selected" : "") + (this.props.className != null ? " " + this.props.className : "");
        return React.createElement("button", { className: classes, title: this.props.title, onClick: () => { this.props.onClick(); }, disabled: this.props.disabled }, this.props.content);
    }
}
export class ClickOutsideWatcher extends React.Component {
    constructor(props) {
        super(props);
        this._childRef = React.createRef();
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick(e) {
        if (this._childRef && e.target instanceof Element && !this._childRef.current.contains(e.target)) {
            this.props.callback();
        }
    }
    componentDidMount() {
        document.addEventListener("pointerdown", this.handleClick);
    }
    componentWillUnmount() {
        document.removeEventListener("pointerdown", this.handleClick);
    }
    render() {
        return React.createElement("div", { className: this.props.className, ref: this._childRef },
            this.props.children,
            " ");
    }
}
//# sourceMappingURL=BasicElements.js.map